<template>
  <router-view></router-view>
</template>

<script setup></script>

<style>
#app {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: rgb(29, 30, 65);
  background: url(@/assets/bg1.jpg) 0% 0% / 100% 100% no-repeat;
}
body {
  margin: 0;
  padding: 0;
  /* font-size: 14px; */
}
</style>
